import { Pipe, PipeTransform } from '@angular/core';
import { PRODUCT_GROUPS } from '../enums/product-groups.enum';
import { Product } from '../interfaces/product.interface';
import { SummaryView, PlanAttributes } from '../interfaces/plan-attributes.interface';

@Pipe({
    name: 'activeProductGroup',
    standalone: false
})
export class ActiveProductGroupPipe implements PipeTransform {

  transform(products: Product<PlanAttributes, SummaryView>[], activeProductGroup: PRODUCT_GROUPS, ...args: any[]): any {
    return products?.filter(product => {
      return product.attributes.PRODUCT_GROUP.toUpperCase() === activeProductGroup.toUpperCase();
    })
  }

}
